/*
 * PokeAlp · Oct. 2026 : option "Toploader" (prix du produit option-toploader, 0.80 CHF pièce).
 *
 * 1. <pa-toploader-option> (snippets/pokealp-toploader-option.liquid) : case à cocher sur la fiche produit
 *    des cartes. Cochée, la carte part au panier avec la propriété "Toploader" (visible dans le panier
 *    et sur la commande) et la propriété cachée "_pa_tl" (nombre de toploaders par article).
 * 2. Synchro : après chaque changement du panier, la quantité du produit toploader est recalculée
 *    = somme (quantité x _pa_tl) des lignes avec toploader. Le client ne la modifie jamais à la main,
 *    le toploader disparaît tout seul quand la carte est retirée.
 * 3. "Acheter maintenant" : ajoute la carte et ses toploaders avant d'aller au paiement.
 */
(function () {
  'use strict';
  if (window.__paToploaderReady) return;
  window.__paToploaderReady = true;

  var cfg = window.paToploader || {};
  var TL = cfg.variantId ? String(cfg.variantId) : null;
  if (!TL) return;

  var KEY = 'Toploader';
  var NKEY = '_pa_tl';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var checkedByForm = {};

  function emit(name) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
  }

  function postJSON(path, body) {
    return nativeFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error(path + ' ' + res.status);
      return res.json();
    });
  }

  function label(n) {
    return n > 1 ? '✓ (×' + n + ')' : '✓';
  }

  /* ---------- Fiche produit ---------- */

  function activeElements(form, name) {
    if (!form) return [];
    return Array.prototype.filter.call(form.elements, function (el) {
      return el.name === name && !el.disabled && ((el.type !== 'radio' && el.type !== 'checkbox') || el.checked);
    });
  }

  class PaToploaderOption extends HTMLElement {
    connectedCallback() {
      if (this._paReady) return;
      this._paReady = true;
      try {
        this.map = JSON.parse(this.getAttribute('data-map') || '{}');
      } catch (e) {
        this.map = {};
      }
      this.input = this.querySelector('.pa-tl__input');
      this.priceEl = this.querySelector('[data-pa-tl-price]');
      this.countEl = this.querySelector('[data-pa-tl-count]');
      if (!this.input) return;
      var key = this.dataset.form || '';
      if (checkedByForm[key]) this.input.checked = true;
      var self = this;
      this.input.addEventListener('change', function () {
        checkedByForm[key] = self.input.checked;
        self.classList.toggle('is-on', self.input.checked);
      });
      this.classList.toggle('is-on', this.input.checked);
      this.refresh();
    }

    get form() {
      return document.getElementById(this.dataset.form) || this.closest('form');
    }

    currentId() {
      var els = activeElements(this.form, 'id');
      return els.length ? String(els[els.length - 1].value) : null;
    }

    quantity() {
      var els = activeElements(this.form, 'quantity');
      var q = els.length ? parseInt(els[0].value, 10) : 1;
      return q > 0 ? q : 1;
    }

    info() {
      var id = this.currentId();
      var i = id && this.map[id];
      return i && i.n > 0 ? i : null;
    }

    isActive() {
      return !!(this.input && this.input.checked && this.info());
    }

    refresh() {
      var i = this.info();
      this.hidden = !i;
      if (!i) return;
      if (this.priceEl) this.priceEl.textContent = i.price;
      if (this.countEl) {
        if (i.n > 1) {
          this.countEl.textContent = i.n + ' × ' + (this.dataset.unit || '');
          this.countEl.hidden = false;
        } else {
          this.countEl.textContent = '';
          this.countEl.hidden = true;
        }
      }
    }
  }

  if (!window.customElements.get('pa-toploader-option')) {
    window.customElements.define('pa-toploader-option', PaToploaderOption);
  }

  function optionFor(form) {
    /* getAttribute : sur un formulaire produit, form.id renvoie le champ <input name="id"> */
    var formId = form && form.getAttribute && form.getAttribute('id');
    if (!formId) return null;
    var list = document.querySelectorAll('pa-toploader-option');
    for (var i = 0; i < list.length; i++) {
      if (list[i].dataset.form === formId) return list[i];
    }
    return null;
  }

  /* Le thème construit le panier avec new FormData(form) : on y glisse les propriétés de la carte. */
  document.addEventListener('formdata', function (e) {
    var opt = optionFor(e.target);
    if (!opt || !opt.isActive()) return;
    var i = opt.info();
    e.formData.set('properties[' + KEY + ']', label(i.n));
    e.formData.set('properties[' + NKEY + ']', String(i.n));
  }, true);

  /* Changement de variante : prix et visibilité de l'option */
  function refreshAll() {
    setTimeout(function () {
      document.querySelectorAll('pa-toploader-option').forEach(function (el) {
        if (el.refresh) el.refresh();
      });
    }, 0);
  }
  document.addEventListener('change', refreshAll);
  document.addEventListener('variant:update', refreshAll);
  document.addEventListener('variant:selected', refreshAll);

  /* "Acheter maintenant" : la carte et ses toploaders partent ensemble au paiement */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-pokealp-buynow]');
    if (!btn) return;
    var opt = optionFor(btn.closest('form'));
    if (!opt || !opt.isActive()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.classList.contains('is-loading')) return;
    var i = opt.info();
    var q = opt.quantity();
    var props = {};
    props[KEY] = label(i.n);
    props[NKEY] = String(i.n);
    btn.classList.add('is-loading');
    postJSON('cart/add.js', {
      items: [
        { id: parseInt(opt.currentId(), 10), quantity: q, properties: props },
        { id: parseInt(TL, 10), quantity: q * i.n }
      ]
    }).then(function () {
      window.location.href = '/checkout';
    }).catch(function (err) {
      console.error('[PokeAlp toploader]', err);
      btn.classList.remove('is-loading');
    });
  }, true);

  /* ---------- Synchro du panier ---------- */

  function perUnit(item) {
    var p = item.properties || {};
    if (p[KEY] == null || p[KEY] === '') return 0;
    var n = parseInt(p[NKEY], 10);
    return n > 0 ? n : 1;
  }

  function counts(items) {
    var want = 0;
    var have = 0;
    items.forEach(function (it) {
      if (String(it.variant_id) === TL) have += it.quantity;
      else want += it.quantity * perUnit(it);
    });
    return { want: want, have: have };
  }

  var timer = null;
  var running = false;
  var pending = false;

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(sync, delay == null ? 400 : delay);
  }

  function sync() {
    if (running) {
      pending = true;
      return;
    }
    running = true;
    nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var c = counts(cart.items || []);
        if (c.want === c.have) return false;
        var updates = {};
        updates[TL] = c.want;
        return postJSON('cart/update.js', { updates: updates }).then(function () { return true; });
      })
      .then(function (changed) {
        if (!changed) return;
        emit('cart:reload');
        emit('currency:update');
      })
      .catch(function (err) {
        console.error('[PokeAlp toploader]', err);
      })
      .then(function () {
        running = false;
        if (pending) {
          pending = false;
          schedule(150);
        }
      });
  }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function isCartWrite(url) {
    return CART_RE.test(String(url || ''));
  }

  /* Toute modification du panier (fetch ou XHR, thème ou apps) relance la synchro */
  var pageFetch = window.fetch;
  window.fetch = function (input) {
    var url = input && typeof input === 'object' && 'url' in input ? input.url : input;
    var p = pageFetch.apply(this, arguments);
    if (isCartWrite(url)) p.then(function () { schedule(); }, function () {});
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) {
      this.addEventListener('loadend', function () { schedule(); });
    }
    return xhrOpen.apply(this, arguments);
  };

  document.addEventListener('cart:update', function () { schedule(); });

  if (cfg.dirty) schedule(0);
})();
